/* eslint-disable */
import React, { useState, useMemo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { assetImages } from "constants";
import ImmunizationFilterPopup from "./Popup/ImmunizationFilterPopup";
import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import SaveImmunizationPopup from "components/Common/Popup/SaveImmunizationPopup";

const ImmunizationsSection = ({
  patientObj = null,
  doctorObj = null,
  clinicObj = null,
}) => {
  const params = useParams();
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [immunizationList, setImmunizationList] = useState([]);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedImmunizationIds, setSelectedImmunizationIds] = useState([]);
  const [selectedImmunizationId, setSelectedImmunizationId] = useState(null);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [isFilterReset, setIsFilterReset] = useState(false);
  const [reloadData, setReloadData] = useState(false);

  // get all immunizations
  const getAllImmunizationsByPatientId = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_IMMUNIZATION +
        `?token=${token}&members=${params.id}`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl += `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("requestUrl in immunization list------->", requestUrl);

      const response = await getData(requestUrl);
      setIsLoading(false);
      if (response.status) {
        setImmunizationList(response.data);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // After any action
  const afterActionClose = (data = []) => {
    setTimeout(() => {
      setImmunizationList((prevList) => mergeListById(prevList, data));
    }, 1000);
  };

  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveImmunizationOffCanvas"
            aria-controls="saveImmunizationOffCanvas"
            onClick={() => {
              setSelectedImmunizationId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false,
        enableColumnDragging: false,
        enableSorting: false,
      },
      {
        header: "Vaccine",
        accessorKey: "vaccinename",
        size: 200,
        Cell: ({ row }) => (
          <div
            className={
              row.original.vaccinename === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.vaccineimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.vaccineimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.vaccinename}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Vaccination For",
        accessorKey: "title",
        size: 160,
      },
      {
        header: "Administered By",
        accessorKey: "doctorname",
        size: 180,
        Cell: ({ row }) => (
          <div
            className={
              row.original.doctorname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.doctorimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.doctorimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.doctorname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Assigned To",
        accessorKey: "assignedpersonname",
        Cell: ({ row }) => (
          <div
            className={
              row.original.assignedpersonname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.assignedpersonimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.assignedpersonimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.assignedpersonname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Facility",
        accessorKey: "clinicname",
        size: 250,
        Cell: ({ row }) => (
          <div
            className={
              row.original.clinicname === ""
                ? "d-none"
                : "owner border-bottom-0 d-flex align-items-center gap-1"
            }
          >
            <img
              className="rounded-circle"
              height={35}
              width={35}
              src={
                row.original.clinicimage == ""
                  ? assetImages.defaultUser
                  : url.SERVER_URL + row.original.clinicimage
              }
              alt="User"
            />
            <p>
              <span className="d-block">{row.original.clinicname}</span>
            </p>
          </div>
        ),
      },
      {
        header: "Date Administered",
        accessorKey: "administereddate",
        size: 160,
      },
      {
        header: "Dose Number",
        accessorKey: "dosenumber",
        size: 120,
      },
      {
        header: "Batch Number",
        accessorKey: "batchnumber",
        size: 120,
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllImmunizationsByPatientId();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getAllImmunizationsByPatientId();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    if (params.id) {
      getAllImmunizationsByPatientId();
    }
  }, [params.id]);

  const reloadList = () => {
    // Reload function placeholder
    console.log("Reloading immunizations list...");
  };

  const updateBulkHandler = () => {
    // Bulk update handler placeholder
    console.log("Bulk update handler...");
  };

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">
      <div className="filter-container mb-4">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <h3 className="mb-3">Vaccinations</h3>
          </div>

          <div className="col-lg-8 d-flex align-items-center justify-content-end gap-1 gap-sm-2">
            <Link to="#" className="btn btn-gray" onClick={resetFilterData}>
              <span className="d-block material-symbols-outlined">refresh</span>
            </Link>

            <Link
              to="#"
              className="btn btn-gray"
              data-bs-toggle="offcanvas"
              data-bs-target="#immunizationFilterOffCanvas"
              aria-controls="immunizationFilterOffCanvas"
            >
              <span className="d-block material-symbols-outlined">tune</span>
            </Link>
            <Link
              to="#"
              className="btn btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#saveImmunizationOffCanvas"
              aria-controls="saveImmunizationOffCanvas"
            >
              Add New
            </Link>
          </div>
        </div>
      </div>
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <div className="table-wrapper">
          <MaterialReactTable
            columns={columns}
            data={immunizationList}
            enableGrouping
            enableRowSelection={false}
            getRowId={(row) => row._id}
            state={{ columnOrder }}
            initialState={{ columnOrder }}
            defaultColumn={{
              minSize: 20,
              maxSize: 300,
              size: 50,
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
              },
            }}
            enableStickyHeader
          />
        </div>
      )}

      {/* popup and modals */}
      <SaveImmunizationPopup
        selectedImmunizationId={selectedImmunizationId}
        setSelectedImmunizationId={setSelectedImmunizationId}
        afterActionClose={afterActionClose}
        patientObj={patientObj}
        doctorObj={doctorObj}
        clinicObj={clinicObj}
      />

      {/* ------- filter popup ------- */}
      <ImmunizationFilterPopup
        setJsonFilterQuery={setJsonFilterQuery}
        reloadList={resetFilterData}
        moduleSlug="patientimmunization"
        isFilterReset={isFilterReset}
        setIsFilterReset={setIsFilterReset}
        columnOrder={columnOrder}
      />
    </div>
  );
};

export default ImmunizationsSection;
